import React, { useContext, useEffect, useState } from "react";
import { maxLengthCheck } from "../../../modules/utils/CheckLogic";
import { DateTimeLayerMod } from "../../Layout";
import styled from "styled-components";
import { postApi } from "../../../modules/network/Network";
import { PostApi1120, PostApi1200 } from "../../../modules/network/padoPost";
import { AppContext } from "../../../components/AppProvider";

export default (props) => {
  return (
    <div
      className="blacklayer-container"
      id="modifyLayer"
      style={{ zIndex: "55", display: "block" }}
    >
      <div className="bl-blind"></div>
      <BpModifyLayer
        setDisplayMod={props.setDisplayMod}
        reloadList={props.reloadList}
        seqNo={props.seqNo}
        targetData={props.targetData}
      />
    </div>
  );
};

const BpModifyLayer = (props) => {
  const { targetData } = props;
  const [date, setDate] = useState(targetData.bpcDate);
  const [time, setTime] = useState(targetData.bpcTime);
  const [bpcTimeCd, setBpcTimeCd] = useState(targetData.bpcTimeCd);
  const { userinfo, cfg, phonecfg, appStdInfo } = useContext(AppContext);

  const checkHrtRate = hrtRate => {
    if (hrtRate != "") {
      if (
        appStdInfo.hrtRateMin <= parseInt(hrtRate) &&
        parseInt(hrtRate) <= appStdInfo.hrtRateMax
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      $("#hrtRate").val("0");
      return true;
    }
  };

  const request1120 = () => {
    if (
      appStdInfo.bpMin <= parseInt($("#inputMaxBp").val()) &&
      parseInt($("#inputMaxBp").val()) <= appStdInfo.bpMax &&
      appStdInfo.bpMin <= parseInt($("#inputMinBp").val()) &&
      parseInt($("#inputMinBp").val()) <= appStdInfo.bpMax &&
      parseInt($("#inputMaxBp").val()) > parseInt($("#inputMinBp").val())
    ) {
      PostApi1120(
        userinfo,
        cfg,
        phonecfg,
        props.seqNo,
        bpcTimeCd,
        date,
        time,
        "L",
        $("#inputMaxBp").val(),
        $("#inputMinBp").val(),
        $("#hrtRate").val() == "" ? "0" : $("#hrtRate").val()
      )
        .then(res => {
          if (res.resultCode === "E000") {
            props.reloadList();
            props.setDisplayMod(false);
            document
              .getElementsByTagName("body")[0]
              .classList.remove("scrollLock");
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      alert("입력한 값을 확인하세요");
    }
  };

  return (
    <div className="in-layerarea">
      <div className={"blgrn-box vertical"}>
        <div className="doctor-message">
          {/* 식전 식후 선택영역 */}
          {/* <DivFlex> */}
          <div>
            <DateTimeLayerMod
              setBpcDate={setDate}
              setBpcTime={setTime}
              setBpcTimeCd={setBpcTimeCd}
              viewDate={targetData.bpcDate}
              viewTime={targetData.bpcTime}
              viewDay={targetData.date2}
              data={targetData}
            />
          </div>
          {/* </DivFlex> */}

          <div style={{ display: "flex", margin: "8px 0px" }}>
            <div
              style={{
                display: "flex",
                background: "#fff",
                height: "46px",
                width: "45%",
                border: "1px solid #d0d0d0",
                borderRadius: "7px",
                padding: "0px 15px",
              }}>
              <div>
                <input
                  type="number"
                  pattern="\d*"
                  id="inputMaxBp"
                  style={{
                    height: "46px",
                    lineHeight: "46px",
                    border: "0px",
                    width: "100%",
                  }}
                  placeholder="최고혈압"
                  onChange={e => maxLengthCheck(e, 3)}
                  defaultValue={targetData.maxBp}
                />
              </div>
              <div>
                <i style={{ lineHeight: "46px", fontSize: "12px" }}>mmHg</i>
              </div>
            </div>
            <div style={{ width: "10%" }}></div>
            <div
              style={{
                display: "flex",
                background: "#fff",
                height: "46px",
                width: "45%",
                border: "1px solid #d0d0d0",
                borderRadius: "7px",
                padding: "0px 15px",
                marginLeft: "auto",
              }}>
              <div>
                <input
                  type="number"
                  pattern="\d*"
                  id="inputMinBp"
                  style={{
                    height: "46px",
                    lineHeight: "46px",
                    border: "0px",
                    width: "100%",
                  }}
                  placeholder="최소혈압"
                  onChange={e => maxLengthCheck(e, 3)}
                  defaultValue={targetData.minBp}
                />
              </div>
              <div>
                <i style={{ lineHeight: "46px", fontSize: "12px" }}>mmHg</i>
              </div>
            </div>
          </div>

          {/* 심박수 */}
          <div
            style={{
              height: "46px",
              border: "1px solid #d0d0d0",
              borderRadius: "7px",
              padding: "0px 15px",
              background: "#fff",
              marginBottom: "8px",
            }}>
            <input
              type="number"
              pattern="\d*"
              id="hrtRate"
              style={{ border: "0px", lineHeight: "46px", width: "100%" }}
              placeholder="심박수"
              onChange={e => maxLengthCheck(e, 3)}
              defaultValue={targetData.hrtRate != "" ? targetData.hrtRate : "0"}
            />
          </div>
          {/* 심박수 */}
        </div>
        {/* 혈당 인풋 박스 */}

        <div className="btn-area" style={{ float: "right" }}>
          <a
            className="btn-round gray"
            onClick={() => {
              props.setDisplayMod(false);
              document
                .getElementsByTagName("body")[0]
                .classList.remove("scrollLock");
            }}>
            취소
          </a>
          <a className="btn-round wht" onClick={() => request1120()}>
            확인
          </a>
        </div>
      </div>
    </div>
  );
};

const DivFlex = styled.div`
  display: flex;
`;
